export const FETCH_UTILISATEUR_SESSION_REQUEST     = "FETCH_UTILISATEUR_SESSION_REQUEST";
export const FETCH_UTILISATEUR_SESSION_SUCCESSFUL  = "FETCH_UTILISATEUR_SESSION_SUCCESSFUL";
export const FETCH_UTILISATEUR_SESSION_FAILURE     = "FETCH_UTILISATEUR_SESSION_FAILURE";

export const UPDATE_UTILISATEUR_SESSION_REQUEST     = "UPDATE_UTILISATEUR_SESSION_REQUEST";
export const UPDATE_UTILISATEUR_SESSION_SUCCESSFUL  = "UPDATE_UTILISATEUR_SESSION_SUCCESSFUL";
export const UPDATE_UTILISATEUR_SESSION_FAILURE     = "UPDATE_UTILISATEUR_SESSION_FAILURE";